import hub from './helpers/sailplay.hub'
import 'sailplay-hub-actions'
import CONFIG from '../config'

const TAGS_CHUNK_SIZE = 10
const SAILPLAY = window.SAILPLAY

export default {

  _chunk(array, chunkSize) {
    return [].concat.apply([], array.map((elem, i) => {
      return i % chunkSize ? [] : [array.slice(i, i + chunkSize)]
    }))
  },

  init() {
    return new Promise((resolve, reject) => {
      SAILPLAY.on('init.success', resolve)
      SAILPLAY.on('init.error', reject)
      SAILPLAY.send('init', {
        partner_id: CONFIG.partner_id,
        domain: CONFIG.domain,
        lang: CONFIG.lang
      })
    })
  },

  login(authHash) {
    return new Promise((resolve, reject) => {
      SAILPLAY.on('login.success', resolve)
      SAILPLAY.on('login.error', reject)
      SAILPLAY.send('login', authHash)
    })
  },

  config() {
    return new Promise((resolve, reject) => {
      SAILPLAY.on('magic.config.success', resolve)
      SAILPLAY.on('magic.config.error', reject)
      SAILPLAY.send('magic.config', CONFIG.remote_config_name)
    })
  },

  userInfo() {
    return new Promise((resolve, reject) => {
      SAILPLAY.send('load.user.info', {
        all: 1,
        purchases: 1
      }, res => {
        if (res.status === 'ok') {
          resolve(res)
        } else {
          reject(res)
        }
      })
    })
  },

  addTags(tags, auth_hash = undefined) {
    const chunkedTags = this._chunk(tags, TAGS_CHUNK_SIZE)
    const promises = chunkedTags.map(chunk => {
      return new Promise((resolve, reject) => {
        SAILPLAY.send('tags.add', { tags: chunk, auth_hash: auth_hash }, res => {
          if (res.status === 'ok') {
            resolve(res)
          } else {
            reject(res)
          }
        })
      })
    })
    return Promise.all(promises)
  },

  giftsList() {
    return new Promise((resolve, reject) => {
      SAILPLAY.on('load.gifts.list.success', resolve)
      SAILPLAY.on('load.gifts.list.error', reject)
      SAILPLAY.send('load.gifts.list')
    })
  },

  getGift(gift) {
    return new Promise((resolve, reject) => {
      SAILPLAY.on('gift.purchase.force_complete.success', resolve)
      SAILPLAY.on('gifts.purchase.error', reject)
      SAILPLAY.send('gifts.purchase', { gift: gift })
    })
  },

  setVariable(custom_vars) {
    return new Promise((resolve, reject) => {
      SAILPLAY.on('vars.add.success', resolve)
      SAILPLAY.on('vars.add.error', reject)
      SAILPLAY.send('vars.add', { custom_vars: custom_vars })
    })
  },

  badgesList() {
    return new Promise((resolve, reject) => {
      SAILPLAY.on('load.badges.list.success', resolve)
      SAILPLAY.on('load.badges.list.error', reject)
      SAILPLAY.send('load.badges.list')
    })
  },

  removeTags(tags, auth_hash = undefined) {
    const chunkedTags = this._chunk(tags, TAGS_CHUNK_SIZE)
    const promises = chunkedTags.map(chunk => {
      return new Promise((resolve, reject) => {
        SAILPLAY.send('tags.delete', { tags: chunk, auth_hash: auth_hash }, res => {
          if (res.status === 'ok') {
            resolve(res)
          } else {
            reject(res)
          }
        })
      })
    })
    return Promise.all(promises)
  },

  loadActions() {
    return new Promise((resolve, reject) => {
      SAILPLAY.on('load.actions.list.success', resolve)
      SAILPLAY.on('load.actions.list.error', reject)
      SAILPLAY.send('load.actions.list')
    })
  },

  loadCustomActions() {
    return new Promise((resolve, reject) => {
      SAILPLAY.on('load.actions.custom.list.success', resolve)
      SAILPLAY.on('load.actions.custom.list.error', reject)
      SAILPLAY.send('load.actions.custom.list')
    })
  },

  userTags() {
    return new Promise((resolve, reject) => {
      SAILPLAY.send('tags.list', {}, res => {
        if (res.status === 'ok') {
          resolve(res)
        } else {
          reject(res)
        }
      })
    })
  },

  userVars() {
    return new Promise((resolve, reject) => {
      SAILPLAY.send('vars.batch', { names: ['Position', 'City', 'p2p_auth', 'm2p_auth', 'edu_auth'] }, res => {
        if (res.status === 'ok') {
          resolve(res)
        } else {
          reject(res)
        }
      })
    })
  },

  userHistory() {
    return new Promise((resolve, reject) => {
      let offset = new Date().getTimezoneOffset()
      let o = Math.abs(offset)
      let timezone = (offset < 0 ? '+' : '-') + ('00' + Math.floor(o / 60)).slice(-2) + ':' + ('00' + (o % 60)).slice(-2)
      SAILPLAY.on('load.user.history.success', resolve)
      SAILPLAY.on('load.user.history.error', reject)
      SAILPLAY.send('load.user.history', {
        tz: timezone
      })
    })
  },

  userUpdate(params) {
    return new Promise((resolve, reject) => {
      SAILPLAY.send('users.update', params, res => {
        if (res.status === 'ok') {
          resolve(res)
        } else {
          reject(res)
        }
      })
    })
  },

  changeAvatar(image) {
    return new Promise((resolve, reject) => {
      if (!image) return resolve()
      const callbackName = 'sailplay_change_avatar_callback'
      let data = new FormData()
      data.append('avatar', image)
      let url = SAILPLAY.config().DOMAIN + SAILPLAY.config().urls.users.update
      url += '?auth_hash=' + SAILPLAY.config().auth_hash
      url += '&callback=' + callbackName
      window[callbackName] = resolve
      let request = new XMLHttpRequest()
      request.overrideMimeType('application/json')
      request.open('POST', url, true)
      request.onload = function () {
        if (request.responseText) {
          eval(request.responseText)
        }
      }
      request.send(data)
    })
  },

  clearAuthHash() {
    SAILPLAY.config().auth_hash = ''
  }

}
